module.exports = __webpack_public_path__ + "static/media/varais-12-copia.6e5c4b30.jpg";